import { FormikProps } from "formik";
import { regPhone } from "common/hooks/utils/utils";
import { OrderFileProps } from "common/hooks/user/order/useGetOrderInfo";

export type FormikFromProps = {
    customer_name: string;
    customer_idx: number | null;
    order_name: string;
    order_mobile: string;
};

export type FormikProductProps = {
    category_idx: number | null;
    product_idx: number | null;
    union_option: boolean; // 임의 추가
};

export type FormikToProps = {
    customer_idx?: number | null;
    customer_name?: string;
    order_name?: string;
    order_mobile?: string;
    // product_idx: number | null;
    wreath_sender: string; // 명의
    wreath_word: string; // 경조사어
    recipient_name: string;
    recipient_mobile: string;
    is_union: boolean;
    event_content_idx: number | null;
    depth1_idx: number | null;
    event_content: string;
    related_person: string;
    work_location: string;
    department: string;
    company_tel: string;
    delivery_immediate: boolean;
    delivery_date: string;
    original_delivery_date: string; // 임의 추가
    delivery_time: string;
    delivery_hour: string; // 임의 추가
    delivery_minute: string; // 임의 추가
    delivery_type: string; // 임의 추가
    original_delivery_hour: string; // 임의 추가
    original_delivery_minute: string; // 임의 추가
    original_delivery_type: string; // 임의 추가
    delivery_post: string;
    delivery_address: string;
    delivery_address_detail: string;
    delivery_memo_idx: number | null;
    delivery_memo: string;
    display_delivery_memo: string; // 임의 추가
    file_memo: string;
    order_memo: string;
    is_visible_event_content_field: boolean;
};

export type NewFormikToProps = {
    order_file: File[];
} & FormikToProps;

export type UpdateFormikToProps = {
    order_file: OrderFileProps[];
    del_file_idx: number[];
} & FormikToProps;

export type OutletContextProps = {
    formik: {
        from: FormikProps<FormikFromProps>;
        product: FormikProps<FormikProductProps>;
        to: FormikProps<NewFormikToProps | UpdateFormikToProps>;
    };
    isSubmitting?: boolean;
};
export const defaultContextValues: OutletContextProps = {
    formik: {
        from: {} as FormikProps<FormikFromProps>,
        product: {} as FormikProps<FormikProductProps>,
        to: {} as FormikProps<NewFormikToProps | UpdateFormikToProps>,
    },
    isSubmitting: false,
};

export const orderFromValidator = (values: any) => {
    const errors: Record<string, string> = {};
    if (!values.order_name) {
        errors.order_name = "이름을 입력하세요.";
    }
    if (!values.order_mobile || !regPhone.test(values.order_mobile)) {
        errors.order_mobile = "연락처를 확인하세요.";
    }

    return errors;
};

export const orderToValidator = (values: any) => {
    const errors: Record<string, string> = {};
    if (!values.recipient_name) {
        errors.recipient_name = "받으시는 분을 입력해주세요.";
    }
    if (!values.recipient_mobile) {
        errors.recipient_mobile = "받으시는 분 연락처를 입력해주세요.";
    }
    if (values.is_visible_event_content_field) {
        if (!values.depth1_idx) {
            errors.depth1_idx = "경조내용을 선택해주세요.";
        }
        if (values.depth1_idx !== 1 && !values.event_content) {
            errors.event_content = "경조내용을 선택해주세요.";
        }
    }
    if (!values.delivery_date) {
        errors.delivery_date = "배송일을 선택해주세요.";
    }
    const deliveryMessage = "배송시간을 선택해주세요.";
    const isSpecialDeliveryHour = values.delivery_hour === "오전중" || values.delivery_hour === "오후중" || values.delivery_hour === "당일배송";
    if (!values.delivery_immediate && !values.delivery_hour) {
        errors.delivery_hour = deliveryMessage;
    }
    if (!values.delivery_immediate && !isSpecialDeliveryHour && !values.delivery_minute) {
        errors.delivery_minute = deliveryMessage;
    }
    if (!values.delivery_immediate && !isSpecialDeliveryHour && !values.delivery_type) {
        errors.delivery_type = deliveryMessage;
    }
    if (!values.delivery_immediate) {
        if (!values.delivery_hour || (!isSpecialDeliveryHour && (!values.delivery_minute || !values.delivery_type))) {
            errors.delivery_time = deliveryMessage;
        }
    }
    if (!values.delivery_post) {
        errors.delivery_post = "우편번호를 선택해주세요.";
    }
    if (!values.delivery_address) {
        errors.delivery_address = "주소를 선택해주세요.";
    }
    // if (!values.delivery_address_detail) {
    //     errors.delivery_address_detail = "상세주소를 입력해주세요.";
    // }
    return errors;
};

export const initialFromValues = {
    customer_idx: null,
    customer_name: "",
    order_name: "",
    order_mobile: "",
};

export const initialProductValues = {
    category_idx: null,
    product_idx: null,
    union_option: false, // 임의 추가
};

export const initialToValues = {
    product_idx: null,
    wreath_sender: "",
    wreath_word: "",
    recipient_name: "",
    recipient_mobile: "",
    is_union: false,
    event_content_idx: null,
    depth1_idx: null,
    event_content: "", // 임의 추가
    related_person: "",
    work_location: "",
    department: "",
    company_tel: "",
    delivery_immediate: false,
    delivery_date: "",
    original_delivery_date: "", // 임의 추가
    delivery_time: "",
    delivery_hour: "", // 임의 추가
    delivery_type: "", // 임의 추가
    delivery_minute: "", // 임의 추가
    original_delivery_hour: "", // 임의 추가
    original_delivery_minute: "", // 임의 추가
    original_delivery_type: "", // 임의 추가
    delivery_post: "",
    delivery_address: "",
    delivery_address_detail: "",
    delivery_memo_idx: null,
    delivery_memo: "",
    display_delivery_memo: "", // 임의 추가
    file_memo: "",
    order_memo: "",
    order_file: [],
    is_visible_event_content_field: false,
};

export const initialUpdateToValues = {
    ...initialToValues,
    del_file_idx: [],
};
